import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import { createUseStyles } from "react-jss";
import { _STYLES } from "../common/utils/customStyles";
import { PERMISSION_FEATURES } from "../permissions/types/permission-types";
import systemNoticeManagementStyles from "./systemNotice-styles";
import SystemNoticeTable from "./table/systemNoticeTable.component";
import SystemNoticeModal from "./modals/systemNoticeModal";

const {
  textMd1,
  colorText,
  paraLine,
  textSm3,
  colorPrimary,
  w100,
  mb1,
  bgWhite,
  fontBold,
  colorAccent,
} = _STYLES;
const { welcome, welcomeContent, welcomeTitle, welcomeSub, welcomeIllustration, welcomeBtn } = systemNoticeManagementStyles;

const useStyles = createUseStyles({
  textMd1,
  colorText,
  paraLine,
  textSm3,
  colorPrimary,
  welcome,
  welcomeContent,
  welcomeTitle,
  welcomeSub,
  welcomeIllustration,
  welcomeBtn,
  w100,
  mb1,
  bgWhite,
  fontBold,
  colorAccent,
});

const SystemNoticeComponent = ({
  isSystemNoticeModalOpen,
  toggleSystemNoticeModal,
  actionCellRenderer,
  refreshTable,
  systemNoticeTableRef,
  systemNoticeModalRef,
  auth,
}) => {
  const classes = useStyles();

  return (
    <Row gutter={[40, 20]}>
      <Col xs={24}>
        <Row gutter={[40, 24]}>
          <Col xs={24}>
            <Row className={classes.welcome}>
              <div className={classes.welcomeContent}>
                <h3 className={classes.welcomeTitle}>Notice Management</h3>
                <p className={classes.welcomeSub}>Publish and manage system-wide notices and alerts</p>
                {auth[PERMISSION_FEATURES.ADD] && (
                  <div className={classes.welcomeBtn}>
                    <Button onClick={toggleSystemNoticeModal} icon={<PlusOutlined />}>Add Notice</Button>
                  </div>
                )}
              </div>
              {/* Bell SVG illustration */}
              <svg className={classes.welcomeIllustration} viewBox="0 0 200 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 22 C70 22 52 44 52 78 L52 100 L34 118 L166 118 L148 100 L148 78 C148 44 130 22 100 22Z" fill="white" fillOpacity="0.9"/>
                <ellipse cx="100" cy="122" rx="18" ry="11" fill="white" fillOpacity="0.7"/>
                <circle cx="150" cy="36" r="16" fill="#66CFF0" fillOpacity="0.9"/>
                <rect x="148.5" y="27" width="3" height="9" rx="1.5" fill="white"/>
                <rect x="148.5" y="39" width="3" height="3" rx="1.5" fill="white"/>
                <path d="M30 60 Q18 78 30 96" stroke="white" strokeOpacity="0.5" strokeWidth="4" fill="none" strokeLinecap="round"/>
                <path d="M170 60 Q182 78 170 96" stroke="white" strokeOpacity="0.5" strokeWidth="4" fill="none" strokeLinecap="round"/>
              </svg>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col xs={24}>
        <SystemNoticeTable
          actionCellRenderer={actionCellRenderer}
          ref={systemNoticeTableRef}
        />
      </Col>
      <SystemNoticeModal
        isModelOpen={isSystemNoticeModalOpen}
        toggleModal={toggleSystemNoticeModal}
        cbOnSave={refreshTable}
        isDisabled={!auth[PERMISSION_FEATURES.EDIT]}
        ref={systemNoticeModalRef}
      />
    </Row>
  );
};

export default SystemNoticeComponent;
